var theme ={
  primaryBackground:"#fff",
  cardColor:"#fff",
  secondaryBackground:"#f9f9f9",
  primaryColor:"#16a5c4",
  primaryTextColor:"#4e4e4e",
  secondaryTextColor:"#888888"
}

export const Colors = {
  primaryBackground: theme.primaryBackground,
  secondaryBackground: theme.secondaryBackground,
  primaryColor: theme.primaryColor,
  primaryTextColor:  theme.textColor,
  secondaryTextColor: theme.secondaryTextColor,
  black:'#000'
}

if(localStorage.getItem('theme') == "dark"){
  theme = {
    primaryBackground:"#000",
    secondaryBackground:"#222",
    cardColor:"#333",
    primaryColor:"#16a5c4",
    primaryTextColor:"#fff",
    secondaryTextColor:"#ccc"
  }
}

export const Theme = {
  cardColor:theme.cardColor,
  primaryBackground: theme.primaryBackground,
  secondaryBackground: theme.secondaryBackground,
  primaryColor: theme.primaryColor,
  primaryTextColor:  theme.primaryTextColor,
  secondaryTextColor: theme.secondaryTextColor
}

export const Values = {
  globalRadius:'40px'
}

export const HeaderHeight = 80;
export const MobileHeaderHeight = 80;

export const CopyrightText = '© Copyright '+ new Date().getFullYear() +' Kathryn Medina and The Joys of Jet Lag. All rights reserved.'

export const PrimaryBookLink = 'https://www.amazon.com/Joys-Jet-Lag-Travelers-Hole/dp/B0BHRGPZ2F/ref=sr_1_1?crid=1YLZTP2IK5GBW&keywords=the+joys+of+jet+lag&qid=1667158738&qu=eyJxc2MiOiIxLjE0IiwicXNhIjoiMC4wMCIsInFzcCI6IjAuMDAifQ%3D%3D&sprefix=the+joys+of+jet+lag%2Caps%2C168&sr=8-1'

export const BookstoreBookLink = 'https://bookshop.org/p/books/the-joys-of-jet-lag-how-to-use-a-traveler-s-mindset-to-not-be-an-a-hole-in-daily-life/18843055?ean=9798986876306'

export const PrimaryReviewLink = 'https://www.goodreads.com/book/show/62976241-the-joys-of-jet-lag?ac=1&from_search=true&qid=i2l3Bs4BqR&rank=1'

export const GrumpleAmazonLink = 'https://www.amazon.com/dp/B0F9R17JXY'

export const GrumpleSquareLink = 'https://square.link/u/nYRbN8Os'

export const GetUrlVariable = (variable) => {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
            return pair[1];
        }
    }
    return (false);
}



// WEBPACK FOOTER //
// ./src/utils/constants.js